import React, { useState, useEffect } from "react";
import styled from "styled-components";
// Components
import FullButton from "../Buttons/FullButton";
// Assets
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";
import TestimonialSliderVideo from "../Elements/TestimonialSliderVideo";
import { Link } from "react-router-dom";
import { supabase } from "../../supabaseClient";

export default function Header() {
  const [dynamicHeaderImage, setDynamicHeaderImage] = useState(null);

  useEffect(() => {
    const fetchHeaderImage = async () => {
      const { data, error } = await supabase
        .from("home-image")
        .select("image")
        .limit(1)
        .single();

      if (data && data.image) {
        setDynamicHeaderImage(data.image);
      }
    };

    fetchHeaderImage();
  }, []);

  return (
    <>
      <Wrapper id="home" className="container flexSpaceCenter">
        <LeftSide className="flexCenter">
          <div>
            <h1
              style={{ fontFamily: "Josefin Sans, sans-serif" }}
              className="extraBold font60"
            >
              Transforming People into Stock Market Experts.
            </h1>
            <HeaderP
              style={{ fontFamily: "Josefin Sans, sans-serif" }}
              className="font17  "
            >
              Jump into the stock market with confidence, Learn from the best,
              Profit like the best,Your success story begins here🚀
            </HeaderP>
            <BtnWrapper>
              <Link to="/courses">
                {" "}
                <FullButton
                  className="bg-[#7620ff]"
                  title="Get Course Details ✅"
                />
              </Link>
            </BtnWrapper>
          </div>
        </LeftSide>
        <RightSide>
          <ImageWrapper>
            <Img
              className="radius8"
              src={dynamicHeaderImage}
              alt="office"
              style={{ zIndex: 9 }}
            />
            <QuoteWrapper className="flexCenter bg-[#0b093b] radius8">
              <QuotesWrapper>
                <QuotesIcon />
              </QuotesWrapper>
              <div>
                <p className="font15 whiteColor">
                  <em>
                    "With Ragul's expert mentorship, conquer the world of stock
                    market and unlock your financial freedom."
                  </em>
                </p>
              </div>
            </QuoteWrapper>
            <DotsWrapper>
              <Dots />
            </DotsWrapper>
          </ImageWrapper>
          <GreyDiv className="lightBg"></GreyDiv>
        </RightSide>
      </Wrapper>
      {/* video testimonialo */}
      <TestimonialSliderVideo />
      {/* <WhoCanJoin/> */}
    </>
  );
}

const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  min-height: 840px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 30px;
  }
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 50px 0;
  line-height: 1.5rem;
  @media (max-width: 960px) {
    padding: 15px 0 50px 0;
    text-align: center;
    max-width: 100%;
  }
`;
const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;
const GreyDiv = styled.div`
  width: 30%;
  height: 700px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  @media (max-width: 960px) {
    display: none;
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;
const Img = styled.img`
  @media (max-width: 560px) {
    width: 80%;
    height: auto;
  }
`;
const QuoteWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 50px;
  max-width: 330px;
  padding: 30px;
  z-index: 99;
  @media (max-width: 960px) {
    left: 20px;
  }
  @media (max-width: 560px) {
    bottom: -50px;
  }
`;
const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;
const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;
